import { generatePdf } from "../../utilities/PDFMakeUtil";

export const pdfRPT232 = (dataReport, setLoading, setDialogPDF) => {
    var header = {
        content: [
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        style: "fontStyle",
                        table: {
                            widths: ["*"],
                            body: [
                                [
                                    {
                                        columns: [
                                            { width: "*", text: "" },
                                            {
                                                width: "auto",
                                                // {
                                                style: { alignment: "right" },
                                                // widths: ["100", "50"],
                                                table: {
                                                    widths: [70, 60, 10],
                                                    style: "fontStyle",
                                                    body: [[{ text: "สัญญาจ้างเลขที่   ", alignment: "right" }, { text: "  " + dataReport.contractNO + "  ", decoration: "underline", decorationStyle: "dotted" }, " "]],
                                                },
                                                layout: "noBorders",
                                                // }
                                            },
                                        ],
                                    },
                                ],
                                [
                                    {
                                        columns: [
                                            { width: "*", text: "" },
                                            {
                                                width: "auto",
                                                table: {
                                                    widths: [50, 60, 10],
                                                    style: "fontStyle",
                                                    body: [[{ text: "เส้นทางที่   ", alignment: "right" }, { text: dataReport.routeInfo == null ? "" : dataReport.routeInfo, decoration: "underline", decorationStyle: "dotted" }, " "]],
                                                },
                                                layout: "noBorders",
                                            },
                                        ],
                                    },
                                ],
                            ],
                        },
                    },
                ],
            },

            { text: "", margin: [0, 20, 0, 8] },
            {
                // style: 'tableExample',
                table: {
                    widths: ["*", 100, 100],
                    headerRows: 2,
                    style: "fontStyle",
                    body: [
                        [{ text: "รายการ", style: "tableHeader", rowSpan: 2, alignment: "center" }, { text: "จำนวนเงิน/บาท", style: "tableHeader", colSpan: 2, alignment: "center" }, {}],
                        [{}, { text: "ครั้งนี้", style: "tableHeader", alignment: "center" }, { text: "ถึงครั้งนี้", style: "tableHeader", alignment: "center" }],
                        ["รวมค่างานงวดนี้ (รวมภาษีมูลค่าเพิ่ม)", { text: "" + dataReport.deliverAmount, alignment: "right" }, { text: "" + dataReport.accrueAmount, alignment: "right" }],
                        [" ", "", ""],
                        [" ", "", ""],
                        [" ", "", ""],
                        [" ", "", ""],
                        [" ", "", ""],
                        ["ยอดรวม (รวมภาษีมูลค่าเพิ่ม)", { text: "" + dataReport.deliverAmount, alignment: "right" }, { text: "" + dataReport.accrueAmount, alignment: "right" }],
                    ],
                },
            },
            { text: "", margin: [0, 20, 0, 8] },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "เสนอขออนุมัติโดยผู้รับจ้าง",
                        style: "fontStyle",
                    },
                    { width: "100", text: "" },
                ],
            },
            { text: "", margin: [0, 50, 0, 8] },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "ลงนาม...............................................................",
                        style: "fontStyle",
                    },
                    { width: "80", text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: " (........................................................)",
                        style: "fontStyle",
                    },
                    { width: "90", text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "..........................................................",
                        style: "fontStyle",
                    },
                    { width: "90", text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "ผู้รับจ้าง",
                        style: "fontStyle",
                    },
                    { width: "150", text: "" },
                ],
            },
            { text: " ", height: 25 },
            { canvas: [{ type: "line", x1: -10, y1: -450, x2: 500, y2: -450, lineWidth: 1 }] }, // x,y --> x,y
            { text: " ", height: 25 },
            {
                columns: [
                    { width: "auto", text: "เรียน" },
                    // { width: '50', text: ' ' },
                    { width: 20, text: "" },
                    { width: "auto", text: "คณะกรรมการตรวจรับพัสดุ" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: 50, text: "" },
                    { width: "auto", text: "ผู้ควบคุมงานได้ตรวจสอบงานก่อสร้างแล้ว ขอรับรองว่างานแล้วเสร็จถูกต้องตามเงื่อนไขสัญญาจ้าง" },
                ],
                style: "fontStyle",
            },
            {
                columns: [{ width: "auto", text: "เห็นสมควรทำการตรวจรับมอบผลงานดังกล่าว ต่อไป " }],
                style: "fontStyle",
            },
            { text: "", margin: [0, 50, 0, 8] },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "ลงนาม...............................................................",
                        style: "fontStyle",
                    },
                    { width: "80", text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "  (........................................................)",
                        style: "fontStyle",
                    },
                    { width: "90", text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "..........................................................",
                        style: "fontStyle",
                        lineHeight: 4,
                    },
                    { width: "90", text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "ผู้ควบคุมงาน",
                        style: "fontStyle",
                    },
                    { width: "150", text: "" },
                ],
            },
        ],
        styles: {
            header: {
                alignment: "right",
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            fontStyle: {
                fontSize: 14,
            },
            tableExample: {
                alignment: "right",
                margin: [0, 5, 0, 15],
            },
            tableHeader: {
                bold: true,
                fontSize: 14,
                color: "black",
            },
            signature: {
                fontSize: 12,
                // alignment: "right",
                decoration: "underline",
                decorationStyle: "dotted",
                decorationColor: "black",
            },
        },
        pageOrientation: "portrait",
        // pageOrientation: "landscape",
        pageSize: "A4",
        pageMargins: [30, 30, 40, 30],
        defaultStyle: {
            font: "THSarabunNew",
            alignment: "justify",
        },
    };

    generatePdf(true, header, (dataUrl) => {
        setDialogPDF({ open: false, pdfURL: dataUrl });
        // setLoading(false);
    });
};
